import { fetchRebook } from '@/api/service'

const getRebook = (context) => {
  fetchRebook().then((response) => {
    context.commit('REBOOK_UPDATED', response)
  })
}

export default {
  getRebook
}
